import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=bbf2bb38&scoped=true&"
import script from "./Service.vue?vue&type=script&lang=js&"
export * from "./Service.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/Service.css?vue&type=style&index=0&id=bbf2bb38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf2bb38",
  null
  
)

export default component.exports